// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__B7e40"};